<template>
    <div class="modal" :class="{ 'is-active': active }" @dblclick.stop>
        <div class="modal-background" @click.stop="$emit('close')"></div>
        <div class="modal-content" @click.stop>
            <youtube
                ref="youtube"
                :video-id="content"
                :fit-parent="true"
                :resize="true"
                :resize-delay="500"
                v-if="type == 'video'"
            />
            <div
                v-else-if="type == 'embed'"
                v-html="content"
                class="is-flex is-justify-content-center"
            ></div>
            <l-project-object-image-gallery
                v-else-if="type == 'images'"
                :images="content"
            />
        </div>
        <button
            class="modal-close is-large"
            aria-label="close"
            @click.stop="$emit('close')"
        ></button>
    </div>
</template>

<script>
import _ from 'underscore';
import LProjectObjectImageGallery from '@/components/LProjectObjectImageGallery';
export default {
    components: {
        LProjectObjectImageGallery,
    },
    props: {
        active: { type: Boolean, default: false },
        type: { type: String, default: '' },
        content: {
            type: [String, Array, FileList, File, Object],
            default: undefined,
        },
    },
    /*data() {
        return {
            inputValue: undefined,
            uploading: false,
            hasErrors: false,
            pasteValue: undefined,
            errorDescription: undefined,
        };
    },*/
    computed: {},
    /*watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (typeof val != 'string') {
                        this.inputValue = _.clone(val); //{ ...val };
                    } else {
                        this.inputValue = val;
                    }
                }
            },
        },
    },*/
    /*destroyed() {
        this.inputValue = undefined;
    },*/
    /*methods: {
        emitInput() {
            if (!this.hasErrors) {
                this.$emit('input', this.inputValue);
            }
        },
        handleError(err) {
            this.hasErrors = true;
            this.uploading = false;
            this.errorDescription = this.$t(`Error.${err}`);
        },
        cancelAction() {
            if (this.componentType == 'location') {
                this.$emit('cancel');
            } else {
                this.$emit('update:active', false);
            }
        },
    },*/
};
</script>

<style scooped>
</style>
